import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    // Initialize theme immediately to prevent flash
    this.initializeThemeImmediately()
    this.initializeTheme()
  }

  initializeThemeImmediately() {
    // This runs as soon as the controller connects to prevent flash
    const savedTheme = localStorage.getItem('theme')
    
    if (savedTheme) {
      // User has made a choice, respect it
      if (savedTheme === 'dark') {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
    } else {
      // No user preference, use system preference
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      if (systemPrefersDark) {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
    }
  }

  initializeTheme() {
    const savedTheme = localStorage.getItem('theme')
    
    if (savedTheme) {
      // User has made a choice, respect it
      if (savedTheme === 'dark') {
        this.enableDarkMode()
      } else {
        this.enableLightMode()
      }
    } else {
      // No user preference, use system preference
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      if (systemPrefersDark) {
        this.enableDarkMode()
      } else {
        this.enableLightMode()
      }
    }
  }

  toggle() {
    if (document.documentElement.classList.contains('dark')) {
      this.enableLightMode()
    } else {
      this.enableDarkMode()
    }
  }

  enableDarkMode() {
    document.documentElement.classList.add('dark')
    localStorage.setItem('theme', 'dark')
    this.updateToggleIcon(true)
  }

  enableLightMode() {
    document.documentElement.classList.remove('dark')
    localStorage.setItem('theme', 'light')
    this.updateToggleIcon(false)
  }

  updateToggleIcon(isDark) {
    if (this.hasToggleTarget) {
      const sunIcon = this.toggleTarget.querySelector('.sun-icon')
      const moonIcon = this.toggleTarget.querySelector('.moon-icon')
      
      if (isDark) {
        sunIcon?.classList.remove('hidden')
        moonIcon?.classList.add('hidden')
      } else {
        sunIcon?.classList.add('hidden')
        moonIcon?.classList.remove('hidden')
      }
    }
  }
}
